export default __webpack_public_path__ + "static/media/shewolf-art.275555bc.png";